// extracted by mini-css-extract-plugin
module.exports = {"region-select":"_2e-tp7k45T","number":"_3VM8_mYzh5","icon-down":"_3RbALc9HYq","popover-width":"_2XnOiLwOzA","col-margin":"Qw6oKqd35h"};